'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './groupFee.routes.js';
import GrpFeeListCtrl from './list/list.controller.js';
import GrpFeeViewCtrl from './view/view.controller.js';
import GrpFeeFormCtrl from './form/form.controller.js';
import GrpFeeAmtModalSvc from './amountModal/amountModal.service.js';

export default angular.module('georgeApp.groupFee',
  [uiRouter])
  .config(routing)
  .controller('GrpFeeListCtrl', GrpFeeListCtrl)
  .controller('GrpFeeViewCtrl', GrpFeeViewCtrl)
  .controller('GrpFeeFormCtrl', GrpFeeFormCtrl)
  .factory('GrpFeeAmtModalSvc', GrpFeeAmtModalSvc)
  .name;
